export const getVwoABTestVariationsEventData: any = (campaignData: any) => {
    let eventData: Record<string, unknown> = {};
    for (const id in campaignData) {
        eventData[`campaign_${id}`] = campaignData[id];
    }
    return eventData;
};
